import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query answerTemplateSearch($text: String!) {
  answerTemplateSearch(text: $text) {
    answerTemplates {
      id
      text
      value
      markers {
        id
        name
        directory {
          id
          name
        }
      }
    }
    terms
  }
}`;

function searchAnswerTemplates(text) {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
    variables: { text },
  }).then((res) => res.data.answerTemplateSearch);
}

export default searchAnswerTemplates;
